module.exports = __webpack_public_path__ + "media/images/smart_phone/portal/slide_03-f4ad6b4847a36ae378f4877a19fbd36f.jpg";